import { render } from "./SaasView.vue?vue&type=template&id=3710d19e&scoped=true"
import script from "./SaasView.vue?vue&type=script&lang=js"
export * from "./SaasView.vue?vue&type=script&lang=js"

import "./SaasView.vue?vue&type=style&index=0&id=3710d19e&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3710d19e"]])

export default __exports__